<template>
  <v-container fluid grid-list-lg pa-0 ma-0>
    <v-card flat>
      <v-card-text>
        <v-container fluid pa-0 ma-0>
          <v-layout row wrap>
            <v-flex xs6 sm4>
              <v-text-field
                label="Post Date"
                v-model="formattedCloseDate"
                append-icon="fa-calendar"
                box
                hide-details
                disabled
              />
            </v-flex>

          </v-layout>

          <v-divider class="primary" />

          <v-layout row wrap>
            <v-spacer/>
            <v-btn color="primary" @click="recreate" v-if="!transaction.settled">Edit Future Payment</v-btn>
            <v-btn color="error" @click="cancel">Cancel Future Payment</v-btn>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import Moment from 'moment'

import Bus from '@/bus'
import ApiMixin from '@/mixins/api'
import AuthMixin from '@/mixins/auth'
import DisplayMixin from '@/mixins/display'
import StoreMixin from '@/store/mixin'

export default {
  mixins: [ApiMixin, AuthMixin, DisplayMixin, StoreMixin],

  data: function () {
    return {
      enabled: false,

      fields: {
        close_date: null
      }
    }
  },

  props: {
    transaction: Object
  },

  mounted () {
    this.fields.close_date = this.transaction.future_post ? Moment.utc(this.transaction.future_post).format('YYYY-MM-DD') : null
  },

  computed: {
    formattedCloseDate () {
      return this.fields.close_date ? Moment(this.fields.close_date).format('MMM-DD-YYYY') : ''
    }
  },

  methods: {
    async init () {},

    async recreate () {
      /*
      try {
        let options = {
          terminal_id: this.transaction.terminal_id,
          transaction_id: this.transaction.id
        }

        Bus.$emit('openWaitModal')

        let result = await this.api({
          method: 'post',
          url: `/terminal/void`,
          data: options
        })
        Bus.$emit('closeWaitModal')

        if (result.data.response.ActionCode === '000') {
          let method = 'ChargeCard'
          if (this.transaction.request_type.startsWith('ach')) {
            method = 'ChargeACH'
          }

          this.$router.push({name: method, query: { rerun: this.transaction.id }})
        } else {
          let error = result.data.response.ResponseText
          if (result.data.response.ErrMsg) {
            error += ': ' + result.data.response.ErrMsg
          }

          Bus.$emit('openModal', {status: 'error', message: error})
        }
      } catch (err) {
        Bus.$emit('openModal', {status: 'error', message: err})
      }
      */
      let method = 'ChargeCard'
      if (this.transaction.request_type.startsWith('ach')) {
        method = 'ChargeACH'
      }
      this.$router.push({name: method, query: { rerun: this.transaction.id }})
    },

    async cancel () {
      try {
        if (!this.transaction || !this.transaction.token_id) {
          throw new Error('Unable to identify transaction')
        }

        if (confirm('Cancelling is not reversable, are you absolutely sure you would like to cancel this future payment?')) {
          // void if it hasn't been settled, as parent will still run even if schedule is cancelled
          let options = {
            terminal_id: this.transaction.terminal_id,
            transaction_id: this.transaction.id
          }

          Bus.$emit('openWaitModal')
          let result = await this.api({
            method: 'post',
            url: `/terminal/void`,
            data: options
          })
          Bus.$emit('closeWaitModal')

          if (result.data) {
            if (result.data.response.ActionCode === '000') {
              Bus.$emit('openModal', {status: 'success', message: 'Payment Cancelled'})
            } else {
              let error = result.data.response.ResponseText
              if (result.data.response.ErrMsg) {
                error += ': ' + result.data.response.ErrMsg
              }
              throw new Error(error)
            }
          } else {
            throw new Error('Unexpected Error')
          }
        }
      } catch (err) {
        Bus.$emit('openModal', {status: 'error', message: err})
      }
    }

  }
}
</script>



// WEBPACK FOOTER //
// src/components/transactions/FuturePayment.vue